//#region Libraries
import styled from "styled-components";
//#endregion

export const Description = styled.p`
    font-size: 14px;
    color: var(--light-gray-5);
    margin: 0;
`;